import React, { useState, useEffect } from 'react';
import { COLORS } from '../App';

const API_BASE = window.location.port === '3000' ? 'http://localhost:4100/api' : window.location.pathname.startsWith('/cmbs') ? '/cmbs/api' : '/api';

export default function DocumentPreview({ docId, onClose }) {
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);
  const [zoom, setZoom] = useState(100);

  useEffect(() => {
    loadPreview();
  }, [docId]);

  const loadPreview = async () => {
    const token = localStorage.getItem('cmbs_token');
    const res = await fetch(`${API_BASE}/documents/preview/${docId}`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((r) => r.json());
    if (res.success) setHtml(res.data.html);
    setLoading(false);
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.7)', zIndex: 1000, display: 'flex', flexDirection: 'column' }}>
      {/* Toolbar */}
      <div style={{ background: COLORS.navy, padding: '10px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ fontFamily: 'Georgia, serif', color: COLORS.gold, fontSize: 16, margin: 0 }}>Document Preview</h3>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <button onClick={() => setZoom(Math.max(50, zoom - 10))}
            style={{ padding: '4px 12px', background: 'transparent', border: `1px solid ${COLORS.gold}`, color: COLORS.gold, borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>-</button>
          <span style={{ color: '#fff', fontSize: 12 }}>{zoom}%</span>
          <button onClick={() => setZoom(Math.min(200, zoom + 10))}
            style={{ padding: '4px 12px', background: 'transparent', border: `1px solid ${COLORS.gold}`, color: COLORS.gold, borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>+</button>
          <button onClick={onClose}
            style={{ padding: '6px 18px', background: COLORS.gold, color: COLORS.navy, border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12, fontWeight: 600, marginLeft: 16 }}>
            Close
          </button>
        </div>
      </div>

      {/* Preview area */}
      <div style={{ flex: 1, overflow: 'auto', background: '#666', padding: 24, display: 'flex', justifyContent: 'center' }}>
        {loading ? (
          <div style={{ color: '#fff', fontSize: 16 }}>Loading preview...</div>
        ) : (
          <div style={{
            width: `${8.5 * zoom / 100}in`, background: '#fff', boxShadow: '0 4px 24px rgba(0,0,0,0.4)',
            padding: '0.75in', transform: `scale(${zoom / 100})`, transformOrigin: 'top center',
            minHeight: '11in',
          }}>
            <div dangerouslySetInnerHTML={{ __html: html }} />
          </div>
        )}
      </div>
    </div>
  );
}
